import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import ModalVideo from 'react-modal-video'
import { Fade, Zoom, Slide, Rotate } from "react-awesome-reveal";
import { Link } from 'react-router-dom';
import Experts from '@components/experts';
import Testimonail from '@components/testimonial';


const Story: React.FC<any> = ({ data, testimonials }) => {

    const [videoOpen, setVideoOpen] = useState('');


    return (
        <>
            <div className="wrap-video home-video">
                <React.Fragment>
                    <ModalVideo channel='youtube' autoplay isOpen={videoOpen} videoId={videoOpen} onClose={() => setVideoOpen('')} />
                </React.Fragment>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <Fade direction="down">
                                <h2 dangerouslySetInnerHTML={{ __html: data?.blocks?.block2?.title }}></h2>
                                <p dangerouslySetInnerHTML={{ __html: data?.blocks?.block2?.content }}></p>

                            </Fade>
                        </div>
                    </div>
                </div>
                {/*                           
                            <Link to={"/"} style={{ "display": "block" }}>Learn More <i className="fa-solid fa-chevron-right"></i></Link> */}

                <Fade direction="down" className="box-container">
                    {/* <div className="mt-5" style={{ position: "inherit" }}>
                        <div className="box">
                            <img src="/assets/images/ASSET3.png" alt="" />
                        </div>

                        <div className="video">
                            <div className='play' onClick={() => setVideoOpen(data?.blocks?.block3?.cta)}>
                                <img src="/assets/images/youtube-play.png" />
                            </div>
                            <a onClick={() => setVideoOpen(data?.blocks?.block3?.cta)}><img src={data?.blocks?.block3?.file} className="video-img" alt="" /></a>
                        </div>

                    </div> */}

                    <div className="conatainer-fluid"><div className="row video-box">
                        <div className="box">
                            <img src="/assets/images/ASSET3.png"  width="267" height="266" alt="ASSET3" />
                        </div><div className="play-icon" onClick={() => setVideoOpen(data?.blocks?.block3?.cta)}><img src="/assets/images/youtube-play.png" width="76" height="76" alt='Youtube Play'/></div><div className="thumbnail css-1vscx9z" style={{ animationDelay: '0ms' }}><div style={{ overflow: 'hidden' }} onClick={() => setVideoOpen(data?.blocks?.block3?.cta)}><img src={data?.blocks?.block3?.file} alt="KwikChat" width="776" height="437" style={{ transition: 'filter 1s linear 0s', background: 'transparent' }} /></div></div></div></div>

                </Fade>

                <Fade direction="down">
                    <h2 className="m-top pt-5" style={{ marginTop: "55px" }} dangerouslySetInnerHTML={{ __html: data?.blocks?.block4?.title }}></h2>
                    <p dangerouslySetInnerHTML={{ __html: data?.blocks?.block4?.content }}></p>
                </Fade>



                <div id="recipeCarousel" className="carousel slide" data-bs-ride="carousel" style={{ position: "relative" }}>
                    <div className="row carousel-inner pt-3" role="listbox">
                        <Slide direction='right' delay={10}>
                            <Experts setVideoOpen={setVideoOpen} data={testimonials}></Experts>
                        </Slide>
                    </div>
                </div>




                <div className="row">
                    <div className="col-md-12">

                        <div className="advantage">

                            <div>
                                <img src="/assets/images/Group7820.svg " width="640" height="643" alt="Group7820" />
                            </div>


                            <div className="content">
                                <Fade direction='down'>
                                    <h2 dangerouslySetInnerHTML={{ __html: data?.groups?.block5?.title }}></h2>
                                    <p dangerouslySetInnerHTML={{ __html: data?.groups?.block5?.description }}></p>
                                </Fade>
                            </div>
                        </div>


                        <div className="rectangle-width">


                            <div className="row">
                                {data?.blocks?.block5?.map((row: any, index) => (<>
                                    <div className="col-md-6 left-side">
                                        <Fade direction='left'>
                                            <div className="pt-4">
                                                <Fade cascade damping={0.5}>
                                                    <h3 dangerouslySetInnerHTML={{ __html: row.title }}></h3>
                                                    <p dangerouslySetInnerHTML={{ __html: row.content }}></p>
                                                </Fade>
                                            </div>
                                        </Fade>
                                    </div>


                                    <div className="col-md-6 right-side">
                                        <Fade direction='right'>
                                            <Zoom>
                                                <img src={row.file} alt={row.title} />
                                            </Zoom>
                                        </Fade>
                                    </div>
                                </>

                                ))}

                            </div>
                        </div>




                    </div>
                </div>


            </div>
        </>
    )
}
export default Story